import { Link } from "react-router-dom";

const NOTICE = "Template text — replace with wording reviewed by your legal adviser before going live.";

const DOCS = {
  terms: {
    title: "Terms of Service",
    sections: [
      ["About these terms", "These terms govern your use of the Meridian Stock Exchange website and client portal. By opening an account you agree to them. [Insert legal entity name, registration number and registered address.]"],
      ["Eligibility", "You must be at least 18 years old, provide accurate information, and complete identity verification before depositing, investing or withdrawing. We may refuse or close accounts at our discretion where permitted by law."],
      ["Your account", "You are responsible for keeping your login details confidential and for all activity on your account. Tell us immediately if you suspect unauthorised access."],
      ["Deposits, investments and withdrawals", "Deposit and withdrawal requests are reviewed before they are processed. Listed prices are set by Meridian. [Describe settlement times, fees, limits and how client money is held.]"],
      ["Regulatory status", "[State the licences or registrations held by the business and the regulator(s) supervising it.]"],
      ["Liability and disputes", "[Insert limitation of liability, complaints procedure, governing law and jurisdiction.]"],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Who we are", "[Insert data controller name and contact details, and data protection officer if applicable.]"],
      ["What we collect", "Account details (name, email), identity verification data (legal name, date of birth, address, ID and proof-of-address documents), transaction history and technical data such as IP address for security logging."],
      ["Why we use it", "To provide your account, verify your identity, prevent fraud and money laundering, meet legal obligations, and respond to your enquiries."],
      ["How we protect it", "Passwords are hashed, identity documents are stored privately and are only accessible to you and authorised staff, and administrative access is logged."],
      ["Retention and your rights", "[Insert retention periods and how users can access, correct or delete their data under applicable law.]"],
    ],
  },
  "risk-disclosure": {
    title: "Risk Disclosure",
    sections: [
      ["Capital at risk", "The value of investments can go down as well as up, and you may get back less than you invest. Past performance is not a reliable indicator of future results."],
      ["Stocks", "Share prices can be volatile and are affected by company performance, market conditions and economic events."],
      ["Real estate", "Property investments are illiquid. Rental yields shown are estimates and are not guaranteed; valuations may change, and selling shares may not always be possible quickly."],
      ["No advice", "Information on this website is not personal financial advice. Consider seeking independent advice before investing."],
      ["Additional disclosures", "[Insert any risk warnings required by your regulator.]"],
    ],
  },
};

export default function Legal({ doc }) {
  const { title, sections } = DOCS[doc];
  return (
    <div className="container-x max-w-3xl py-16" data-testid={`legal-page-${doc}`}>
      <p className="eyebrow">Legal</p>
      <h1 className="mt-3 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl">{title}</h1>
      <p className="mt-6 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-300">{NOTICE}</p>
      <div className="mt-10 space-y-8">
        {sections.map(([h, body]) => (
          <section key={h}>
            <h2 className="font-display text-lg font-semibold text-white">{h}</h2>
            <p className="mt-2 leading-relaxed text-slate-400">{body}</p>
          </section>
        ))}
      </div>
      <p className="mt-12 text-sm text-slate-500">Questions? <Link to="/contact" className="text-emerald-400 hover:underline">Contact us</Link>.</p>
    </div>
  );
}
